module.exports = __webpack_public_path__ + "static/media/create_multiple.33b0cf2c.png";